import {Component, Input, ContentChild, OnInit} from '@angular/core';

interface PanelButton {
  isActive: boolean;
  buttonText: string;
  buttonRoute?: string;
}

@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
  noData: boolean = false;

  @Input() heading: string = '';
  @Input() subHeading: string = '';
  @Input() icon: { isActive: boolean, iconType: string } = { isActive: true, iconType: '' };
  @Input() headerButton: PanelButton = { isActive: false, buttonText: 'Default Btn' };
  @Input() customClass: string = '';
  @Input() seeAllIsActive: boolean = false;
  @Input() noDataButton: PanelButton = { isActive: false, buttonText: 'Default Btn', buttonRoute: '' };
  @ContentChild('contentComponent') contentComponent: any;

  @Input() set componentData(cd: any | null) {
    this.noData = cd?.length === 0;
  };

  ngOnInit() {

  }

  triggerHeaderButtonFunction(): void {
    if (this.contentComponent) {
      this.contentComponent.headerButtonFunction();
    }
  }
}
